import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

interface IGetAllWorkersSuccessWithDataAction {
  message: string;
}

function getAllSuccessWithoutData(
  draft: Draft<IWorkerData>,
  action: PayloadAction<IGetAllWorkersSuccessWithDataAction>,
) {
  draft.getAll.config.emptyMsg = action.payload.message;
  draft.getAll.config.isLoading = false;
  draft.getAll.list = [];
}

export default getAllSuccessWithoutData;
